<template>
    <div v-if="form">
        <rkm-form
            show-legend
            ref="RkmForm"
        >
            <rkm-area
                title="Paciente"
                type="fieldset"
            >
                <template v-if="hasPaciente">
                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-input
                                v-model="form.pacienteIdentificado.prontuario"
                                label="Prontuário"
                                disabled
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                v-model="form.pacienteIdentificado.cns"
                                label="CNS"
                                disabled
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input
                                v-model="form.pacienteIdentificado.nome"
                                label="Nome"
                                disabled
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input
                                v-model="form.pacienteIdentificado.nomeSocial"
                                label="Nome social"
                                disabled
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input
                                v-model="form.pacienteIdentificado.nomeMae"
                                label="Nome da mãe"
                                disabled
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-input
                                v-model="form.pacienteIdentificado.sexo.descricao"
                                label="Sexo"
                                disabled
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-input
                                v-model="form.pacienteIdentificado.dataNascimento"
                                label="Data de nascimento"
                                disabled
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-group
                                label="Idade"
                                :label-for="uniqueId('age')"
                            >
                                <div
                                    :id="uniqueId('age')"
                                    class="age d-flex align-items-center justify-content-around"
                                >
                                    <div class="d-flex flex-column align-items-center">
                                        <span>
                                            <strong>{{ form.pacienteIdentificado.idade.anos }}</strong>
                                        </span>

                                        <span>
                                            {{ form.pacienteIdentificado.idade.anos > 1 ? 'Anos' : 'Ano' }}
                                        </span>
                                    </div>

                                    <div class="d-flex flex-column align-items-center">
                                        <span>
                                            <strong>{{ form.pacienteIdentificado.idade.meses }}</strong>
                                        </span>

                                        <span>
                                            {{ form.pacienteIdentificado.idade.meses > 1 ? 'Meses' : 'Mês' }}
                                        </span>
                                    </div>

                                    <div class="d-flex flex-column align-items-center">
                                        <span>
                                            <strong>{{ form.pacienteIdentificado.idade.dias }}</strong>
                                        </span>

                                        <span>
                                            {{ form.pacienteIdentificado.idade.dias > 1 ? 'Dias' : 'Dia' }}
                                        </span>
                                    </div>
                                </div>
                            </rkm-form-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-area title="Endereço">
                        <rkm-row>
                            <rkm-col>
                                <rkm-form-input
                                    v-model="form.pacienteIdentificado.endereco"
                                    disabled
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area title="Telefones">
                        <rkm-row>
                            <rkm-col>
                                <Telefones
                                    ref="telefones"
                                    readonly
                                    :telefones="form.pacienteIdentificado.telefones"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-row>
                        <rkm-col class="text-right">
                            <rkm-button
                                v-if="handleEdit(form.pacienteIdentificado)"
                                :label="false"
                                color="primary"
                                @click.stop="$refs.ModalPacienteCadastroSimplificado.open(pacienteId)"
                            >
                                Atualizar cadastro
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>

                    <ModalPacienteCadastroSimplificado
                        ref="ModalPacienteCadastroSimplificado"
                        @save="reloadPaciente($event)"
                    />
                </template>

                <template v-else>
                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-select
                                :options="form.pacienteDesconhecido.sexos"
                                :validations="validations.pacienteDesconhecido.sexo"
                                label="Sexo"
                                show-default-option
                                text-field="descricao"
                                v-model="model.pacienteDesconhecido.sexoId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.pacienteDesconhecido.caracteristicasFisicas"
                                label="Características físicas"
                                rows="5"
                                v-model="model.pacienteDesconhecido.caracteristicasFisicas"
                            />
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-area>

            <rkm-row cols="3">

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        v-model="form.dataRegistro"
                        label="Data do Registro"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        :max-date="form.dataAtual"
                        :min-date="form.dataAtualMenosUmAno"
                        :validations="validations.atendidoEm"
                        label="Data do atendimento"
                        v-model="model.atendidoEm"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-time-picker
                        :validations="validations.atendidoHora"
                        label="Início do atendimento"
                        v-model="model.atendidoHora"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        v-model="model.motivoAtendimento"
                        label="Motivo do atendimento"
                        :validations="validations.motivoAtendimento"
                        :rows="2"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        v-model="model.acompanhante"
                        label="Acompanhante"
                        :validations="validations.acompanhante"
                        :disabled="form.semAcompanhante"
                        uppercase
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-checkbox v-model="form.semAcompanhante">
                                    Sem acompanhante
                                </rkm-form-checkbox>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="7">
                    <rkm-form-input-autocomplete
                        :disabled="!form.isEncaminhamento"
                        :repository="repositoryAutoCompleteUnidadeEncaminhamento"
                        :searchFields="fields.autocomplete.unidadeEncaminhamento"
                        :validations="validations.unidadeEncaminhamento"
                        label="Unidade solicitante"
                        textField="nomeFantasia"
                        uppercase
                        v-model="form.unidadeEncaminhamento"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text>
                                <rkm-form-checkbox v-model="form.isEncaminhamento">
                                    Encaminhamento
                                </rkm-form-checkbox>
                            </rkm-input-group-text>

                            <rkm-form-select
                                :disabled="!form.isEncaminhamento"
                                :options="form.origensUnidade"
                                class="m-0"
                                text-field="nome"
                                v-model="form.origemUnidadeValue"
                                value-field="id"
                            />
                        </rkm-input-group-prepend>

                        <rkm-input-group-append
                            v-if="isOrigemExterna"
                            slot="append"
                        >
                            <rkm-button
                                :disabled="!form.isEncaminhamento"
                                @click="$refs.UnidadeExterna.open()"
                                color="primary"
                                title="Cadastrar unidade externa"
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col cols="5">
                    <rkm-form-input
                        :disabled="!form.isEncaminhamento"
                        :validations="validations.medicoSolicitanteEncaminhamento"
                        label="Médico solicitante"
                        uppercase
                        v-model="model.medicoSolicitanteEncaminhamento"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-select
                        :disabled="form.isEncaminhamento"
                        :options="form.origensEntrada"
                        :validations="validations.origemEntrada"
                        label="Origem de entrada"
                        textField="nome"
                        v-model="model.origemEntradaId"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="9">
                    <rkm-form-input
                        :disabled="!isOrigemSamu"
                        :validations="validations.medicoSamu"
                        label="Médico(a) SAMU"
                        uppercase
                        v-model="model.medicoSamu"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :rows="5"
                        :validations="validations.observacao"
                        label="Observação"
                        name="observacao"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <unidade-externa
            ref="UnidadeExterna"
            @save="form.unidadeEncaminhamento = $event"
        />
    </div>
</template>

<script>
// Moment.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { error, data, formats, mask, unmask, repository, object, stringCase } from '@/mixins'

// Enums.
import origemEntrada from '@/enums/pronto-atendimento/origemEntrada'
import sexo from '@/enums/cadastro/cidadao/sexo'
import statusPlantao from '@/enums/pronto-atendimento/plantao/status'
import classificacao from '@/enums/cadastro/paciente/classificacao'

// Components.
import Telefones from '@/components/cadastro/cidadao/Telefone'
import ModalPacienteCadastroSimplificado from '@/components/cadastro/paciente/components/cadastro-simplificado/Modal'
import UnidadeExterna from '@/components/cadastro/unidade-externa/Modal'

export default {
    components: {
        Telefones,
        ModalPacienteCadastroSimplificado,
        UnidadeExterna,
    },
    computed: {
        hasPaciente() {

            return !!this.pacienteId
        },
        validations() {

            return {
                atendidoEm: { required: true },
                atendidoHora: { required: true },
                origemEntrada: { required: true },
                pacienteDesconhecido: {
                    sexo: { required: true },
                    caracteristicasFisicas: { required: true, max: 500 }
                },
                medicoSamu: { max: 150 },
                motivoAtendimento: { required: true, max: 3000 },
                acompanhante: {
                    required: !this.form.semAcompanhante,
                    min: 6,
                    max: 150,
                    termo_invalido: this.adittional.termosInvalidos,
                    name: true,
                },
                unidadeEncaminhamento: { required: this.form.isEncaminhamento },
                medicoSolicitanteEncaminhamento: {
                    required: this.form.isEncaminhamento,
                    min: 6,
                    max: 150,
                    name: true,
                },
                observacao: { max: 500 }
            }
        },
        isOrigemSamu() {

            return this.model.origemEntradaId === this.enums.origemEntrada.SAMU
        },
        isOrigemExterna() {

            return this.form.origemUnidadeValue === 'externa'
        },
        repositoryAutoCompleteUnidadeEncaminhamento() {

            return this.form.origemUnidadeValue === 'interna'
                ? this.repositories.unidade
                : this.repositories.unidadeExterna
        },
        fields() {

            return {
                autocomplete: {
                    unidadeEncaminhamento: [
                        { key: 'nome_fantasia', searchable: true },
                    ],
                }
            }
        },
    },
    created() {

        this.repositories = {
            atendimentoRetroativo: this.getConectaSusRepository('prontoAtendimento.atendimentoRetroativo'),
            unidade: this.getConectaSusRepository('cadastro.estabelecimento.unidade'),
            unidadeExterna: this.getConectaSusRepository('cadastro.estabelecimento.unidadeExterna'),
        }

        this.load()
    },
    data: () => ({
        enums: {
            origemEntrada,
            sexo,
            statusPlantao,
            classificacao,
        },
        adittional: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const params = {}

            if (this.pacienteId) {

                params.paciente_id = this.pacienteId
            }

            this.repositories.atendimentoRetroativo.create(params)
                .then(({ data }) => {

                    this.handleAlertFaaAberta(data)

                    this.adittional = data.adittional
                    this.form = data.form
                    this.model = data.model

                    this.$emit('paciente', data.form.pacienteIdentificado)
                })
                .catch((error) => {

                    this.$emit('load-error')
                    this.handleError(error)
                    this.$router.push({ name: 'pronto-atendimento-atendimento-retroativo-index' })
                })
                .finally(() => this.unsetLoading())
        },
        handleAlertFaaAberta(data) {

            if (data.form.faaAberta.alertFaaAberta) {

                this.showConfirmation(
                    `O paciente já possui uma FAA em aberto em <strong>${data.form.faaAberta.setor}</strong>. Deseja continuar?`,
                    async () => {},
                    async () => {
                        this.$emit('load-error'),
                        this.$router.push({ name: 'pronto-atendimento-atendimento-retroativo-index' })
                    }
                )
            }
        },
        reloadPaciente(paciente) {

            this.form.pacienteIdentificado.prontuario = paciente.prontuario
            this.form.pacienteIdentificado.cns = paciente.cidadao.cns ? this.formatCns(paciente.cidadao.cns) : null
            this.form.pacienteIdentificado.nome = paciente.cidadao.nome
            this.form.pacienteIdentificado.nomeSocial = paciente.cidadao.nomeSocial
            this.form.pacienteIdentificado.nomeMae = paciente.cidadao.nomeMae
            this.form.pacienteIdentificado.sexo.id = paciente.cidadao.sexo.id
            this.form.pacienteIdentificado.sexo.descricao = paciente.cidadao.sexo.descricao
            this.form.pacienteIdentificado.dataNascimento = this.formatDate(paciente.cidadao.dataNascimento)
            this.form.pacienteIdentificado.idade.anos = paciente.cidadao.idade.anos
            this.form.pacienteIdentificado.idade.meses = paciente.cidadao.idade.meses
            this.form.pacienteIdentificado.idade.dias = paciente.cidadao.idade.dias

            let endereco = ''

            if (paciente.cidadao.domicilio) {

                endereco = paciente.cidadao.domicilio.endereco
                endereco = endereco.completo + ' - ' + this.formatCep(endereco.logradouro.cep)
            }

            this.form.pacienteIdentificado.endereco = endereco

            this.form.pacienteIdentificado.telefones = paciente.cidadao.telefones.map(telefone => {

            telefone.numero = this.formatPhoneOrCellPhone(telefone.numero)

                return telefone
            })
        },
        save() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.atendimentoRetroativo.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()

                            this.$emit('save', data)
                            this.$router.push({ name: 'pronto-atendimento-atendimento-retroativo-index' })
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive({
                paciente: this.getPacienteData(),
                atendidoEm: moment(
                        moment(this.model.atendidoEm).format('DD/MM/YYYY') + ' ' +
                        this.model.atendidoHora,
                        'DD/MM/YYYY HH:mm'
                    ).format('DD-MM-YYYY HH:mm'),
                origemEntradaId: this.model.origemEntradaId,
                medicoSamu: this.model.medicoSamu,
                acompanhante: this.model.acompanhante,
                unidadeEncaminhamentoId: this.getUnidadeEncaminhamento('interna'),
                unidadeExternaEncaminhamentoId: this.getUnidadeEncaminhamento('externa'),
                medicoSolicitanteEncaminhamento: this.model.medicoSolicitanteEncaminhamento,
                motivoAtendimento: this.model.motivoAtendimento,
                observacao: this.model.observacao
            })
        },
        getPacienteData() {

            if (this.pacienteId) {

                return { id: this.pacienteId }
            }

            return {
                sexo_id: this.model.pacienteDesconhecido.sexoId,
                caracteristicas_fisicas: this.model.pacienteDesconhecido.caracteristicasFisicas,
            }
        },
        getUnidadeEncaminhamento(origemUnidade) {

            if (this.form.origemUnidadeValue === origemUnidade) {

                return this.form.unidadeEncaminhamento ? this.form.unidadeEncaminhamento.id : null
            }

            return null
        },
        handleEdit(item) {

            if (this.form.isPermissaoCadastro) {
                return true;
            }

            const classificacoes = this.form.classificacoes;
            const classificacaoId = item.classificacaoId;

            const isClassificacaoPresent = (classificacaoId) => {
                return classificacoes.some(classificacao => classificacao.id === classificacaoId);
            };

            switch (classificacaoId) {
                case this.enums.classificacao.MUNICIPE:
                case this.enums.classificacao.PROVISORIO:
                case this.enums.classificacao.OUTRO_MUNICIPIO:
                    return isClassificacaoPresent(classificacaoId);
                default:
                    return false;
            }
        }
    },
    mixins: [
        error,
        data,
        formats,
        mask,
        unmask,
        repository,
        object,
        stringCase,
    ],
    props: {
        pacienteId: { type: Number, default: null },
    },
    watch: {
        'form.isEncaminhamento': function (isEncaminhamento) {

            if (isEncaminhamento) {

                this.model.origemEntradaId = null
                this.model.medicoSamu = null

                return
            }

            this.model.origemEntradaId = this.enums.origemEntrada.ESPONTANEA
            this.form.unidadeEncaminhamento = null
            this.model.medicoSolicitanteEncaminhamento = ''
        },
        'form.origemUnidadeValue': function () {

            this.form.unidadeEncaminhamento = null
        },
        'form.semAcompanhante': function (semAcompanhante) {

            if (semAcompanhante) {

                this.model.acompanhante = null
            }
        }
    }
}
</script>

<style scoped>

.age {
    height: 34.5px;
    min-width: 140px;
    max-width: 225px;
    border: 1px solid #ced4da;
    border-radius: 0.50rem;
}

.age span {
    height: 1.14rem;
}
</style>